// Generated by CoffeeScript 2.7.0
var MATCHING_OPTIONS, SettingsRegister;

import SettingsContainer from 'trunks/vue/admin/components/settings/settings_container.js';

import OptionGroup from 'trunks/vue/share/components/option_group.js';

MATCHING_OPTIONS = ['fuzzy_matching', 'exact_matching'];

export default SettingsRegister = Vue.extend({
  components: {
    'settings-container': SettingsContainer,
    'option-group': OptionGroup
  },
  props: {
    activeTab: {
      type: String
    },
    register: {
      type: Object
    }
  },
  data: function() {
    return {
      settingsRegister: this._generateRegister(),
      matchingOptions: this._generateMatchingOptions()
    };
  },
  template: `<settings-container :activeTab="activeTab">
  <template slot="content">
    <div class="form-field-group field-list-two-item">
      <div class="form-field-group-head helper-text">其他设置</div>
      <div class="form-field inline">
        <div class="form-field-head">
          <div class="form-field-title">开放注册</div>
        </div>
        <div class="form-field-input-container">
          <div class="form-field-input">
            <label class="switch">
              <input type="checkbox"
                      v-model="settingsRegister.signup_enable">
              <span></span>
            </label>
          </div>
        </div>
      </div>
      <div v-show="settingsRegister.signup_enable"
           class="form-field inline">
        <div class="form-field-head">
          <div class="form-field-title">加入组织</div>
        </div>
        <div class="form-field-input-container">
          <div class="form-field-input">
            <label class="switch">
              <input type="checkbox"
                      v-model="settingsRegister.join_organizations_after_sign_up">
              <span></span>
            </label>
            <div class="helper-text">（注册后跳转到申请组织页面）</div>
          </div>
        </div>
      </div>
    </div>
    <div class="form-field-group field-list-two-item">
      <div class="form-field-group-head helper-text">加入组织设置</div>
      <div class="form-field inline">
        <div class="form-field-head">
          <div class="form-field-title">入口设置</div>
        </div>
        <div class="form-field-input-container">
          <div class="form-field-input">
            <label class="switch">
              <input type="checkbox"
                      v-model="settingsRegister.join_organizations_is_close">
              <span></span>
            </label>
            <div class="helper-text">（控制手机端加入组织的入口显示）</div>
          </div>
        </div>
      </div>
      <div v-show="settingsRegister.join_organizations_is_close"
           class="form-field inline" >
        <div class="form-field-head">
          <div class="form-field-title">搜索方式</div>
        </div>
        <div class="form-field-input-container">
          <div class="form-field-input">
            <option-group  optionsClass="search-exact"
                          :initialValue="[statusOption]"
                          :options="matchingOptions"
                          :multiple="false"
                          :canCancelSingleSelect="false"
                          @valueChange="onOptionValueChangeFunc"
                          ref="optionRef" />
          </div>
        </div>
      </div>
      <div v-show="settingsRegister.join_organizations_is_close"
           class="form-field inline" >
        <div class="form-field-head">
          <div class="form-field-title">展示列表</div>
        </div>
        <div class="form-field-input-container">
          <div class="form-field-input">
            <label class="switch">
              <input type="checkbox"
                      v-model="settingsRegister.join_organizations_search_list">
              <span></span>
            </label>
            <div class="helper-text">（控制手机端“加入组织”内的组织展示列表展示）</div>
          </div>
        </div>
      </div>
    </div>
    <div class="form-field inline" >
      <div class="form-field-head">
        <div class="form-field-title">注册后跳转链接</div>
      </div>
      <div class="form-field-input-container">
        <div class="form-field-input">
          <label class="switch">
            <input type="checkbox"
                    v-model="settingsRegister.redirect_after_registered.enable">
            <span></span>
          </label>
          <div class="form-field-input-container" v-show="settingsRegister.redirect_after_registered.enable">
            <div class="form-field-input">
              <input v-model="settingsRegister.redirect_after_registered.url"
                     class="form-field-value"
                     type="text"
                     placeholder="请输入" >
            </div>
            <div class="message">不能为空</div>
          </div>
        </div>
      </div>
    </div>
    </div>
    <div class="content-footer">
      <button class="content-footer-btn"
              @click="updateSettings">更新</button>
    </div>
  </template>
</settings-container>`,
  computed: {
    statusOption: function() {
      if (this.register.join_organizations_search_exact_match === false) {
        return _.first(this.matchingOptions);
      } else {
        return _.last(this.matchingOptions);
      }
    }
  },
  methods: {
    updateSettings: function() {
      var data;
      data = {
        namespace: {}
      };
      _.each(this.settingsRegister, function(item, key) {
        if (key === 'redirect_after_registered') {
          return data.namespace[key] = item;
        } else if (key === 'join_organizations_is_close') {
          return data.namespace[key] = Boolean(!item);
        } else {
          return data.namespace[key] = Boolean(item);
        }
      });
      return Skylark.Libs.Ajax.patch('/admin/settings/register.json', {
        data: data,
        responseType: 'json',
        contentType: 'application/json; charset=utf-8',
        success: function(data) {
          return Skylark.Bridge.newAlertify('更新成功', {
            type: 'success'
          });
        },
        error: function(xhr, status, err) {
          return Skylark.Bridge.newAlertify('更新失败', {
            type: 'danger'
          });
        }
      });
    },
    onOptionValueChangeFunc: function(option) {
      return this.settingsRegister.join_organizations_search_exact_match = option[0].id === MATCHING_OPTIONS[0] ? Boolean(false) : Boolean(true);
    },
    _generateRegister: function() {
      return {
        signup_enable: Boolean(this.register.signup_enable),
        join_organizations_after_sign_up: Boolean(this.register.join_organizations_after_sign_up),
        join_organizations_is_close: Boolean(!this.register.join_organizations_is_close),
        join_organizations_search_exact_match: Boolean(this.register.join_organizations_search_exact_match),
        join_organizations_search_list: Boolean(this.register.join_organizations_search_list),
        redirect_after_registered: {
          enable: Boolean(this.register.redirect_after_registered.enable),
          url: this.register.redirect_after_registered.url
        }
      };
    },
    _generateMatchingOptions: function() {
      return _.map(MATCHING_OPTIONS, function(option_id) {
        return new Skylark.App.Model.FieldOption({
          id: option_id,
          value: Skylark.Helpers.translate("settings.register." + option_id)
        });
      });
    }
  }
});
